<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :total="total"
      :tableData="tableData"
      :pageParams="queryParams"
      @pageChange="handleSearch"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleSee(scope.data, scope.$index)"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':fenceDetail']"
          class="button"
          type="text"
          size="small"
          @click="handleFence(scope.data, scope.$index)"
        >围明细</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type !=='preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/library/village/components/form'
import { getRegiontList, getRegiontDetail, delregion } from '@/api/library/vallage'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    return {
      authIdentity: 'library:village',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      type: '',
      colLists: [
        {
          prop: 'name',
          label: '村名称',
          isTrue: true,
          align: 'left'
        },
        {
          prop: 'parentFullName',

          label: '所属地区',
          isTrue: true,
          align: 'left'
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        level: 6,
      },
      tableData: [{ code: 'xx' }],
      selectOrInputList: [
        {
          model: 'name',
          placeholder: '请输入村名称',
          class: 'home',
          type: 'input',
        },
        {
          model: 'parentFullName',
          placeholder: '请输入所属地区',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.getRegiontList()
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delregion(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功！`)
              this.getRegiontList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    submitFrom() {
      console.log('进来')
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data)

        if (data) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getRegiontList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增村'

        this.type = 'add'
        this.$refs.myform.add(this.type)
      })
    },
    handleSee(row) {
      getRegiontDetail(row.id)
        .then((res) => {
          if (res.flag) {
            let data = res.data
            data.parentFullCodeList = res.data.parentFullCodeList
            data.name = res.data.name
            data.parentFullName = res.data.parentFullName
            data.level = res.data.level
            data.id = res.data.id
            data.level = 6
            this.dialogVisible = true
            this.title = '查看村'
            this.currentView = 'myform'
            this.type = 'preview'
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data, this.type)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleUpdata(row) {
      getRegiontDetail(row.id)
        .then((res) => {
          if (res.flag) {
            let data = res.data
            data.parentFullCodeList = res.data.parentFullCodeList
            data.name = res.data.name
            data.parentFullName = res.data.parentFullName
            data.level = res.data.level
            data.id = res.data.id
            data.level = 6
            this.dialogVisible = true
            this.currentView = 'myform'
            this.type = 'edit'
            this.title = '修改村'
            console.log(data, 'datadatadata-------------------------------------------')
            this.$nextTick(() => {
              this.$refs.myform.getDetail(data)
            })

            // this.formData.parentFullCodeList = res.data.parentFullCodeList
            // this.formData.name = res.data.name
            // this.formData.parentFullName = res.data.parentFullName
            // this.formData.level = res.data.level
            // this.formData.id = res.data.id
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })

      // this.$nextTick(() => {
      //   this.title = '修改行政区域管理'
      //   console.log(that.$refs.myform, ' this.$refs.my111111111111form.getDetail------------')
      //   this.$refs.myform.getDetail(row)

      //   this.type = 'edit'
      // })
    },
    handleFence(row) {
      console.log('围明细')
      console.log(row, 'row')
      this.$router.push({
        path: '/fence',
        query: {
          parentId: row.id,
          name: row.name,
          parentFullName: row.parentFullName,
          parentFullCodeList: row.parentFullCodeList,
          code: row.code,
        },
      })
    },
    getRegiontList() {
      getRegiontList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getRegiontList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        level: 6,
      }
      this.getRegiontList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
/deep/ .el-button--text {
  font-size: 14px;
}
</style>